import React from 'react'
import Check from '@mui/icons-material/Check'

export default function SummaryKpiTile({
  label,
  value,
  support,
  icon: Icon,
  tone,
  selected,
  onClick
}) {
  const Component = onClick ? 'button' : 'div'
  return (
    <Component
      className={`daily-control-kpi daily-control-kpi--${tone || 'default'}`}
      {...(onClick ? { type: 'button', onClick, 'aria-pressed': selected } : {})}
    >
      <span className="daily-control-kpi-heading">
        <span className="daily-control-kpi-icon" aria-hidden="true">
          <Icon size={14} />
        </span>
        <span className="daily-control-kpi-label">{label}</span>
        {selected && (
          <Check
            className="daily-control-kpi-check"
            sx={{ fontSize: 11 }}
            aria-hidden="true"
          />
        )}
      </span>
      <span className="daily-control-kpi-value">{value}</span>
      <span className="daily-control-kpi-support">{support}</span>
    </Component>
  )
}
